import { IocKey as IocKeyCore } from '@ztechapps/common.contract'
import merge from 'lodash/merge'

export const IocKey = merge(IocKeyCore, {
  config: {
    quickscoreScanModelConfig: Symbol.for('quickscore.config.scanModel'),
    quickscoreWebsiteConfig: Symbol.for('quickscore.config.website'),
  },
  quickscore: {
    repository: {
      assessment: Symbol.for('quickscore.repository.assessment'),
      assessmentResult: Symbol.for('quickscore.repository.assessmentResult'),
      scanBatch: Symbol.for('quickscore.repository.scanBatch'),
      school: Symbol.for('quickscore.repository.school'),
      schoolInvite: Symbol.for('quickscore.repository.schoolInvite'),
      teacher: Symbol.for('quickscore.repository.teacher'),
    },
    service: {
      previewSchoolInvite: Symbol.for('quickscore.service.previewSchoolInvite'),
      redeemSchoolInvite: Symbol.for('quickscore.service.redeemSchoolInvite'),
      startTeacherConversation: Symbol.for('quickscore.service.startTeacherConversation'),
    },
    queue: {
      batchScan: Symbol.for('quickscore.queue.batchScan'),
    },
    gateway: {
      visionModel: Symbol.for('quickscore.gateway.visionModel'),
    },
  },
})
